<template>
  <div>
    <div class="commonSearch" ref="commonSearchRef">
      <el-tabs
        v-model="tabName"
        style="height: 90vh; background-color: #fff"
        label-width="100px"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane label="报修单查询" name="first">
          <div style="margin-bottom: 20px">
            <el-form class="el-form el-form--inline">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="报修单号：">
                    <el-input
                      v-model="form.repaircode"
                      placeholder="模糊匹配"
                      style="width: 180px"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="学生校区：">
                    <el-select
                      v-model="form.region"
                      placeholder="请选择"
                      style="width: 180px"
                      filterable
                    >
                      <el-option
                        v-for="item in xqqys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="报修日期：">
                    <el-date-picker
                      style="width: 180px"
                      v-model="form.selectdate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="6">
                  <el-form-item label="故障类型：">
                    <el-select
                      v-model="form.faulttype"
                      placeholder="请选择"
                      style="width: 180px"
                      filterable
                    >
                      <el-option
                        v-for="item in gzlxs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态：">
                    <el-select
                      v-model="form.status"
                      placeholder="请选择"
                      style="width: 180px"
                      filterable
                    >
                      <el-option
                        v-for="item in ddzts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="派单状态：">
                    <el-select
                      v-model="form.repairStatus"
                      placeholder="请选择"
                      style="width: 180px"
                      filterable
                    >
                      <el-option
                        v-for="item in repairStatuses"
                        :key="item.id"
                        :label="item.name"
                        :value="item.extCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" @click="initData('first')"
                    >查询</el-button
                  >
                  <el-button type="primary" plain @click="form = {}"
                    >清空</el-button
                  >
                  <el-button type="primary" plain @click="exportOrder('first')"
                    >导出</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div>
            <el-table
              :height="firstTabHeight"
              style="width: 100%"
              :data="returndata"
              ref="datas"
              size="medium"
              v-loading="loading"
              element-loading-text="拼命加载中"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#000000',
                borderRight: '1px solid #fff',
              }"
            >
              <el-table-column
                prop="repaircode"
                label="报修单号"
                min-width="130"
              >
              </el-table-column>
              <el-table-column
                prop="regionName"
                label="学生校区"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="faulttypeName"
                label="故障类型"
                min-width="120"
              >
              </el-table-column>
              <el-table-column prop="statusName" label="状态" min-width="80">
              </el-table-column>
              <el-table-column prop="ostatus" label="派单状态" min-width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.ostatus == null">未派单</span>
                  <span v-if="scope.row.ostatus == 1">已派单</span>
                  <span v-if="scope.row.ostatus == 2">已接单</span>
                  <span v-if="scope.row.ostatus == 3">已完成</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="repersonnel"
                label="接单人员"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="createdate"
                label="报修时间"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="remarks"
                label="备注"
                min-width="120"
                :show-overflow-tooltip="true"
              >
              </el-table-column>

              <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                  <span class="caozuo" @click="toOrderView(scope.row)"
                    >明细</span
                  >
                  <span class="caozuo" @click="reclick(scope.row)"
                    >&emsp;|&emsp;备注</span
                  >
                  <span
                    class="caozuo"
                    @click="pdan(scope.row)"
                    v-if="scope.row.orderrepairid == null"
                    >&emsp;|&emsp;派单</span
                  >
                  <span
                    class="caozuo"
                    v-if="
                      scope.row.ostatus != 0 &&
                      (scope.row.status == 100405 || scope.row.status == 100402)
                    "
                    @click="toEvaluateView(scope.row)"
                    >&emsp;|&emsp;查看</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label">
            <span class="span-box">
              <span>派单超时报修单</span>
              <span
                class="btn-bell-badge"
                v-if="this.$utils.isEmpty(this.csCount)"
              >
                <span class="num">{{ this.csCount }}</span>
              </span>
            </span>
          </span>
          <div style="margin-bottom: 20px">
            <el-form class="el-form el-form--inline">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="报修单号：">
                    <el-input
                      v-model="frm.repaircode"
                      placeholder="模糊匹配"
                      style="width: 180px"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="学生校区:">
                    <el-select
                      v-model="frm.region"
                      placeholder="请选择"
                      style="width: 180px"
                      clearable
                    >
                      <el-option
                        v-for="item in xqqys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="故障类型:">
                    <el-select
                      v-model="frm.faulttype"
                      placeholder="请选择"
                      style="width: 180px"
                    >
                      <el-option
                        v-for="item in gzlxs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" @click="initData('second')"
                    >查询</el-button
                  >
                  <el-button type="primary" plain @click="frm = {}"
                    >清空</el-button
                  >
                  <el-button type="primary" plain @click="exportOrder('second')"
                    >导出</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div>
            <el-table
              :height="secondTabHeight"
              style="width: 100%"
              :data="returndata2"
              ref="datas"
              element-loading-text="拼命加载中"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#000000',
                borderRight: '1px solid #fff',
              }"
            >
              <el-table-column
                prop="repaircode"
                label="报修单号"
                min-width="130"
              >
              </el-table-column>
              <el-table-column
                prop="regionName"
                label="学生校区"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="faulttypeName"
                label="故障类型"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="timeout"
                label="派单超时长(小时)"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="repersonnel"
                label="接单人员"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="createdate"
                label="报修时间"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="repairtime"
                label="预约时间"
                min-width="150"
              >
              </el-table-column>

              <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                  <span class="caozuo" @click="toOrderView(scope.row)"
                    >明细</span
                  >
                  <span
                    class="caozuo"
                    @click="pdan(scope.row)"
                    v-if="scope.row.orderrepairid == null"
                    >&emsp;|&emsp;派单</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <div class="commonPage" align="right">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="cur_page"
            :page-sizes="[5, 10, 15, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
        <div>
          <DistDlg v-if="DistDlgShow" ref="DistDlgRef"></DistDlg>
<!-- 备注弹窗 -->
          <el-dialog
            title="备注"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
            :close-on-click-modal="false"
          >
            <span> <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="remarks" style="width: 26vw" maxlength="50" show-word-limit> </el-input></span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleClose">取 消</el-button>
              <el-button type="primary" @click="saveremar"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
import DistDlg from "./DispatchOrder.vue";
import FaultApi from "@/api/fault.js";
import RepairsApi from "@/api/repairs.js";
export default {
  mixins: [TabResize],
  components: { DistDlg },
  data() {
    return {
      form: {
        repaircode: "",
        region: "",
        faulttype: "",
        status: "",
        selectdate: "",
        repersonnel: "",
        repairStatus: "",
        
      },
      remarks:"",
      remakid:"",
      dialogVisible:false,
      frm: {
        repaircode: "",
        buliding: "",
        region: "",
        faulttype: "",
      },
      orderid: "",
      options: [],
      loading: true,
      cur_page: 1,
      per_page: "",
      totalCount: 0,
      csCount: 0,
      returndata: [],
      returndata2: [],
      tablestatus: "pzxx",
      DistDlgShow: false,
      tabName: "first",
      gzlxs: [], //故障类型
      xqqys: [], //校区
      ddzts: [], //状态
      repairStatuses: [], //派单状态
      firstTabHeight: parseFloat(document.documentElement.clientHeight - 310),
      secondTabHeight: parseFloat(document.documentElement.clientHeight - 263),
    };
  },

  mounted: function () {
    this.initData("first");
    this.findOptions("1002", "gzlxs");
    this.findOptions("1003", "xqqys");
    this.findOptions("1004", "ddzts");
    this.findOptions("2001", "repairStatuses");
  },
  methods: {

      handleClose(done) {
          this.dialogVisible = false;
      },
      reclick(row){
          this.dialogVisible = true;
          console.log(row);
            this.remakid = row.orderid
            this.remarks = row.remarks
            this.$forceUpdate();
      },
      saveremar () {
          console.log(this.remarks);
          console.log(this.remakid);
                if (this.$utils.isEmpty(this.remarks)) {
                    let param = {
                        orderid: this.remakid,
                        remarks: this.remarks,
                    }
                    RepairsApi.getClass()
                        .saveOrUpdate(param)
                        .then(resp => {
                            if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                                this.$message.success("保存成功！");
                                this.initData("first");
                                this.loading = false;
                                this.dialogVisible = false;
                            } else {
                                this.$message.error(resp.data.msg);
                            }
                        }).catch(err => {
                            this.loading = false;
                            this.$message.error(err);
                        });
                }
        },
    pdan(row) {
      this.DistDlgShow = true;
      this.$nextTick(() => {
        this.$refs.DistDlgRef.init(row, this.tabName);
      });
    },
    handleClick(tab, event) {
      this.cur_page = 1;
      this.initData(tab.name);
    },

    findOptions(code, key) {
      SettingApi.getClass()
        .Findcode(code)
        .then((resp) => {
          if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
            this[key] = resp.data.data;
            if (key == "xqqys") {
              for (let i = 0; i < this[key].length; i++) {
                if (this[key][i].code == "100304") {
                  this[key].splice(i, 1);
                }
              }
            }
          } else {
            this.$message.error(resp.data.msg);
            return false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          return false;
        });
    },

    toOrderView(row) {
      this.$router.push({
        name: "OrderView",
        params: { row },
      });
    },

    toEvaluateView(row) {
      this.$router.push({
        name: "EvaluateView",
        params: { row },
      });
    },

    //报修列表
    initData(tabName) {
      let param;
      if (tabName == "first") {
        this.returndata = [];
        param = {
          tabName: tabName,
          repaircode: this.form.repaircode,
          region: this.form.region,
          faulttype: this.form.faulttype,
          status: this.form.status,
          selectdate: this.form.selectdate,
          repersonnel: this.form.repersonnel,
          repairStatus: this.form.repairStatus,
          pageNum: this.cur_page,
          pageSize: this.per_page,
        };
      } else {
        this.returndata2 = [];
        param = {
          tabName: tabName,
          repaircode: this.frm.repaircode,
          region: this.frm.region,
          faulttype: this.frm.faulttype,
          pageNum: this.cur_page,
          pageSize: this.per_page,
        };
      }
      FaultApi.getClass()
        .findPages(param)
        .then((resp) => {
          if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
            this.totalCount = resp.data.data.totalElements;
            let _data = resp.data.data.data;

            if (tabName == "first") {
              this.returndata = _data;
            } else {
              this.csCount = resp.data.data.totalElements;
              this.returndata2 = _data;
            }
          } else {
            this.$message.error(resp.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
      this.loading = false;
    },

    // 导出
    exportOrder(tabName) {
      let param;
      if (tabName == "first") {
        param = {
          tabName: tabName,
          repaircode: this.form.repaircode,
          region: this.form.region,
          faulttype: this.form.faulttype,
          status: this.form.status,
          selectdate: this.form.selectdate,
          repersonnel: this.form.repersonnel,
          repairStatus: this.form.repairStatus,
        };
      } else {
        param = {
          tabName: tabName,
          repaircode: this.frm.repaircode,
          region: this.frm.region,
          faulttype: this.frm.faulttype,
        };
      }
      FaultApi.getClass()
        .exportOrder(param)
        .then((resp) => {
          this.$utils.downloadFile(resp.data, "报修单导出.xlsx");
        })
        .catch((err) => {
          this.$message.error(err);
          return false;
        });
      this.loading = false;
    },

    //切换每页显示多条
    handleSizeChange(val) {
      this.per_page = val;
      this.cur_page = 1;
      this.loading = true;
      this.initData(this.tabName);
    },

    // 切换显示第几页
    handleCurrentChange(val) {
      this.cur_page = val;
      this.loading = true;
      this.initData(this.tabName);
    },
  },
};
</script>

<style lang="stylus" scoped>
.caozuo {
  color: #3D84FF;
  cursor: pointer;
}

/deep/.el-button--small {
  margin-left: 20px;
}

/deep/.commonSearch {
  padding: unset;
}

.span-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .btn-bell-badge {
    width: 35px;
    height: 18px;
    margin-left: 5px;
    line-height: 18px;
    border-radius: 15px;
    background: #f56c6c;

    .num {
      display: block;
      text-align: center;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>